import React, {useState} from 'react';
import axios from 'axios';
import DataTable from '../../../../common/DataTable';
import TableRowsPerPage from '../../../../common/TableRowsPerPage';
import Form from 'react-bootstrap/Form'; // Import Form for the switch
import moment from 'moment';
import 'bootstrap/dist/css/bootstrap.min.css'; // Make sure Bootstrap CSS is included
import Snackbar from '../../../../common/Snackbar';
import {TABLE_HEADERS} from './TableHeader';
import {
  Table,
  OverlayTrigger,
  Tooltip,
  Row,
  ToggleButton,
} from 'react-bootstrap';
import {
  AddPicklistItem,
  UpdatePicklistItem,
  SortPicklistItem,
} from '../../../../services/PickListApi';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../redux/Store';
import {validatePicklistItem} from './PicklistValidations';
//import { se } from "date-fns/locale";

type Row = {
  id: number;
  Picklistitemid: number;
  itemName: string;
  displayName: string;
  description: string;
  comments: string;
  sortSequence: any;
  isActive: boolean;
  isEditing: boolean;
  originalData?: Row; // Store the original data for reverting edits
  isNew?: boolean; // Indicates whether the row is a new row
  createdBy?: number;
  createdDate?: string;
  modifiedBy?: number;
  modifiedDate?: string;
  createdbyName?: string;
  createddate?: string;
  modifiedbyName?: string;
  modifieddate?: string;
  loggedInUserId?: any;
};

interface EditableTableProps {
  rows: Row[];
  setRows: React.Dispatch<React.SetStateAction<Row[]>>;
  isSaving: number | null;
  setIsSaving: React.Dispatch<React.SetStateAction<number | null>>;
  selectedGroupId: string | null;
  fetchPicklistItems?: (groupId: number) => void; // Now optional
}

const EditableTable: React.FC<EditableTableProps> = ({
  rows,
  setRows,
  isSaving,
  setIsSaving,
  selectedGroupId,
  fetchPicklistItems,
}) => {
  const [field1, setField1] = useState('');
  const [field2, setField2] = useState('');
  const [field3, setField3] = useState('');
  const [field4, setField4] = useState('');
  const [field5, setField5] = useState('');

  const handleChange = (setter: any) => (event: any) => {
    setter(event.target.value);
  };
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [rowdisble, setrowdisble] = useState<boolean>(false);
  const [itemsPerPage, setItemsPerPage] = useState<number | string>(1000); // Assuming 1000 is a safe upper limit

  const [tooltipData, setTooltipData] = useState<Row | null>(null); // State to hold the tooltip data
  const [tooltipVisible, setTooltipVisible] = useState<boolean>(false); // Control tooltip visibility
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  // const [showSortingIcons, setShowSortingIcons] = useState(false);
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const loggedInUserName = useSelector(
    (state: RootState) => state.auth.username,
  );

  const [isAddButtonDisabled, setIsAddButtonDisabled] = useState(false);
  const [isAddButtonToggle, setIsAddButtonToggle] = useState<boolean>(true);
  const [isAddButtonToggle1, setIsAddButtonToggle1] = useState<number>(1);
  // Function to handle toggle switch changes
  const handleToggleChange = () => {
    setIsAddButtonToggle((prevState) => !prevState); // Toggle the state
  };
  const [editingRowId, setEditingRowId] = useState<number | null>(null); // Track editing row
  const [snackbarSeverity, setSnackbarSeverity] = useState<
    'error' | 'success' | 'info' | 'warning'
  >('error');

  const totalPages = Math.ceil(rows.length / Number(itemsPerPage));
  const indexOfLastRow = currentPage * Number(itemsPerPage);
  const indexOfFirstRow = indexOfLastRow - Number(itemsPerPage);
  // Pagination logic

  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);
  const showSortingIcons = true;
  const [inputValues, setInputValues] = useState<string[]>(Array(7).fill(''));

  const handlePageClick = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const handleInputChange = (
    index: number,
    field: string,
    value: string | number,
  ) => {
    const updatedRows = [...rows];
    updatedRows[index] = {...updatedRows[index], [field]: value};
    setRows(updatedRows);
  };

  // Function to show Snackbar
  const showSnackbar = (
    message: string,
    severity: 'error' | 'success' | 'info' | 'warning',
  ) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenSnackbar(true);
  };
  const alphanumericWithSpacesRegex = /^[a-zA-Z0-9\s]*$/;

  const handleAddClick = async () => {
    const errors = validatePicklistItem(
      field1,
      field2,
      field3,
      field4,
      field5,
      isAddButtonToggle,
      rows,
    );

    if (errors.length > 0) {
      const formattedErrors = errors.join('\n');
      showSnackbar(formattedErrors, 'error');
      return;
    }
    const rowData: Row = {
      id: 0, // Provide a default value or generate an ID if needed
      Picklistitemid: 0, // Provide a default value or generate an ID
      loggedInUserId: loggedInUserid,
      createdbyName: 'loggedInUserName',
      itemName: field1,
      displayName: field2,
      description: field3,
      comments: field4,

      //picklistgroupid: selectedGroupId,
      sortSequence: Number(field5),
      isActive: isAddButtonToggle, // Keep it as boolean
      isEditing: false, // Default value (can be true if editing)
    };
    console.log(
      'Request Payload Before API:',
      JSON.stringify(rowData, null, 2),
    );
    //handleRowAction("save", rowData); // Pass the updated rowData
    const apiPayload = {
      ...rowData,
      picklistgroupid: selectedGroupId,
      isActive: rowData.isActive ? 1 : 0, // Convert boolean to number
      itemdescription: rowData.description,
    };

    try {
      const response = await AddPicklistItem(apiPayload);
      console.log('API Response:', response);
      if (response.isSuccess) {
        // Reset input fields

        // Fetch the updated picklist items if required
        if (fetchPicklistItems && selectedGroupId) {
          fetchPicklistItems(Number(selectedGroupId));
        }

        // Show success message
        showSnackbar('PickList Item added successfully!', 'success');
        setField1('');
        setField2('');
        setField3('');
        setField4('');
        setField5('');
        setIsAddButtonToggle(true);
      } else {
        showSnackbar(response.message || 'Failed to add row.', 'error');
      }
    } catch (error) {
      showSnackbar(
        `Error adding row: ${
          error instanceof Error ? error.message : 'Unknown error'
        }`,
        'error',
      );
    }
  };

  const handleCancel = (row: Row) => {
    if (row.isNew) {
      setRows(rows.filter((r) => r.id !== row.id));
      setIsAddButtonDisabled(false);
    } else {
      const updatedRows = rows.map((r) =>
        r.id === row.id ? {...r, isEditing: false, ...r.originalData} : r,
      );
      setRows(updatedRows);
    }
    setEditingRowId(null); // Reset editing state
    setrowdisble(false);
  };
  const validateItemName = (
    itemName1: string,
    currentRowId: number,
  ): string | null => {
    // Check if alphanumeric (including spaces) and length <= 100
    const alphanumericWithSpacesRegex = /^[a-zA-Z0-9\s,._\-!@#$%^&*()+=]*$/;
    const itemName = itemName1.trim(); // Remove leading/trailing spaces
    // Check if itemName matches the alphanumeric and space constraint
    if (!alphanumericWithSpacesRegex.test(itemName)) {
      return 'Item Name must be alphanumeric and can include spaces only.';
    }
    if (itemName.length == 0) {
      return 'Item Name is mandatory.';
    }
    // Check for length constraint (ensure length is <= 100)
    if (itemName.length > 100) {
      return 'Item Name cannot exceed 100 characters.';
    }

    // Check for uniqueness within the group, excluding the current row being edited
    const isUnique = !rows.some(
      (row) => row.itemName === itemName && row.id !== currentRowId,
    );
    if (!isUnique) {
      return 'Item Name must be unique within the Picklist Group.';
    }

    return null; // No validation errors
  };
  const validateDisplayName = (
    displayName1: string,
    rows: Row[],
    currentRowId: number,
  ): string | null => {
    const displayName = displayName1.trim();
    // Check if alphanumeric (including spaces) and length <= 200
    const alphanumericWithSpacesRegex = /^[a-zA-Z0-9\s,._\-!@#$%^&*()+=]*$/;

    if (!alphanumericWithSpacesRegex.test(displayName)) {
      return 'Display Name must be alphanumeric and can include spaces only.';
    }
    if (displayName.length == 0) {
      return 'Display Name is mandatory.';
    }
    if (displayName.length > 200) {
      return 'Display Name cannot exceed 200 characters.';
    }

    // Check for uniqueness within the group, excluding the current row
    const isUnique = !rows.some(
      (row) => row.displayName === displayName && row.id !== currentRowId,
    );
    if (!isUnique) {
      return 'Display Name must be unique within the Picklist Group.';
    }

    return null; // No errors
  };
  const validateDescription = (description: string): string | null => {
    if (description && description.length > 0) {
      // Only validate if Description is not empty
      const alphanumericWithSpacesRegex = /^[a-zA-Z0-9\s,._\-!@#$%^&*()+=]*$/;
      if (!alphanumericWithSpacesRegex.test(description)) {
        return 'Description must be alphanumeric and can include spaces only.';
      }
      if (description.length > 300) {
        return 'Description cannot exceed 300 characters.';
      }
    }
    return null;
  };

  const validateComments = (description: string): string | null => {
    if (description && description.length > 0) {
      // Only validate if Description is not empty
      const alphanumericWithSpacesRegex = /^[a-zA-Z0-9\s,._\-!@#$%^&*()+=]*$/;
      if (!alphanumericWithSpacesRegex.test(description)) {
        return 'Description must be alphanumeric and can include spaces only.';
      }
      if (description.length == 300) {
        return 'Description cannot exceed 300 characters.';
      }
    }
    return null;
  };

  // Validation function for Sort Sequence
  const validateSortSequence = (
    sortSequence: number | string,
    rows: Row[],
    currentRowId: number,
  ): string | null => {
    // Ensure sortSequence is a number
    const sortSequenceNumber =
      typeof sortSequence === 'string'
        ? parseInt(sortSequence, 10)
        : sortSequence;

    if (
      sortSequence === '' ||
      sortSequence === null ||
      sortSequence === undefined
    ) {
      return 'Sort Sequence is mandatory.';
    }
    // Handle invalid or NaN values
    if (isNaN(sortSequenceNumber)) {
      return 'Sort Sequence must be a valid number.';
    }

    if (sortSequenceNumber <= 0) {
      return 'Sort Sequence must be a positive integer.';
    }

    // Check for uniqueness within the group, excluding the current row
    const isUnique = !rows.some(
      (row) =>
        row.sortSequence === sortSequenceNumber && row.id !== currentRowId,
    );
    if (!isUnique) {
      return 'Sort Sequence must be unique within the Picklist Group.';
    }

    return null; // No validation errors
  };

  const handleRowAction = async (action: string, row: Row) => {
   
    setrowdisble(true);
    if (action === 'edit') {
      console.log('Editing row:', row); // Debugging
      // Prevent editing if a row is already being edited
      if (!row || !row.id) {
        showSnackbar('Error: Row ID is missing!', 'error');
        return; // Prevent further actions
      }

      if (editingRowId !== null && editingRowId !== row.id) {
        showSnackbar(
          'Please save or cancel the current edit before editing another row.',
          'warning',
        );
        return; // Prevent switching to another row before saving/canceling
      }

      console.log('Setting editingRowId to:', row.id);
      setEditingRowId(row.id);

      const updatedRows = rows.map((r) => ({
        ...r,
        isEditing: r.id === row.id, // Only this row should be editable
      }));

      setRows(updatedRows);
      console.log('Rows after setting edit mode:', updatedRows);

      //setEditingRowId(row.id); // Set the current row to be edited
    } else if (action === 'save') {
      if (editingRowId !== row.id) {
        showSnackbar(
          'Please save or cancel the current edit before saving another row.',
          'warning',
        );
        return;
      }
      const errors: string[] = [];

      const itemNameError = validateItemName(row.itemName, row.id);
      if (itemNameError) errors.push(itemNameError);

      const displayNameError = validateDisplayName(
        row.displayName,
        rows,
        row.id,
      );
      if (displayNameError) errors.push(displayNameError);

      const commentError = validateComments(row.description);
      if (commentError) errors.push(commentError);
      console.log(rows, row.id, 'rowsrowsrows');
      if (row.originalData?.isActive === false && row.isActive === true) {
        if (
          rows.some(
            (existingRow) =>
              existingRow.id !== row.id && // Ignore itself
              existingRow.isActive && // Only check active rows
              existingRow.sortSequence === row.sortSequence,
          )
        ) {
          errors.push('Sort Sequence must be unique among active items.');
        }
      } else if (row.originalData?.isActive === false) {
        if (
          rows.some(
            (existingRow) =>
              existingRow.id !== row.id && // Ignore itself
              !existingRow.isActive && // Only check active rows
              existingRow.sortSequence === row.sortSequence,
          )
        ) {
          errors.push('Please active the picklist item before save.');
        }
      }
      // Remove duplicates if any
      const uniqueErrors = [...new Set(errors)];

      // Show all errors together in one snackbar with correct numbering
      if (uniqueErrors.length > 0) {
        const formattedErrors = uniqueErrors.join('\n');
        showSnackbar(formattedErrors, 'error');
        setrowdisble(false);
        return;
      }

      const currentDate = moment().format('YYYY-MM-DDTHH:mm:ss.SSSSSS');
      const requestData = {
        picklistitemid: row.id || row.Picklistitemid,
        picklistgroupid: selectedGroupId,
        itemname: row.itemName,
        displayname: row.displayName,
        sortsequence: row.sortSequence,
        isactive: row.isActive ? 1 : 0,
        itemdescription: row.description,
        comments: row.comments,
        createdByName: row.createdbyName,
        createddate: row.createddate
          ? moment(row.createddate).format('YYYY-MM-DDTHH:mm:ss.SSSSSS')
          : currentDate,
        modifiedByName: row.modifiedbyName,
        modifieddate: row.modifieddate
          ? moment(row.modifieddate).format('YYYY-MM-DDTHH:mm:ss.SSSSSS')
          : currentDate,
        loggedInUserId: loggedInUserid,
      };

      try {
        let response: any;
        console.log('Sending Request Data:', requestData); // Debugging
        if (row.Picklistitemid == 0) {
          response = await AddPicklistItem(requestData);
          console.log('API Response:', response);

          if (response.isSuccess) {
            if (fetchPicklistItems && selectedGroupId) {
              fetchPicklistItems(Number(selectedGroupId)); // TypeScript ensures it's a string here
            }
          }
        } else {
          response = await UpdatePicklistItem(requestData);

          if (response.isSuccess) {
            if (fetchPicklistItems && selectedGroupId) {
              fetchPicklistItems(Number(selectedGroupId)); // TypeScript ensures it's a string here
            }
          }
        }

        if (response?.isSuccess && response?.statusCode === 200) {
          const updatedRows = rows.map((r) => ({
            ...r,
            isEditing: false, // Exit edit mode for all rows
            isNew: false,
            Picklistitemid:
              r.id === row.id
                ? response.result?.picklistitemid || r.Picklistitemid
                : r.Picklistitemid,
          }));
          setField1('');
          setField2('');
          setField3('');
          setField4('');
          setField5('');
          setIsAddButtonToggle(true);
          setRows(updatedRows);
          showSnackbar('PickList Item saved successfully!', 'success');
          setEditingRowId(null); // Reset editing state after save
        } else {
          showSnackbar(response?.message || 'Failed to save the row.', 'error');
        }
      } catch (error) {
        showSnackbar(
          `Error saving row: ${
            error instanceof Error ? error.message : 'Unknown error'
          }`,
          'error',
        );
      } finally {
        setIsAddButtonDisabled(false);
        setrowdisble(false);
      }
    } else if (action === 'cancel') {
      if (editingRowId !== row.id) {
        showSnackbar(
          'You can only cancel the currently edited row.',
          'warning',
        );
        return;
      }

      const updatedRows = rows.map((r) => ({
        ...r,
        isEditing: false, // Cancel edit mode
      }));

      setRows(updatedRows);
      setEditingRowId(null);
      showSnackbar('Edit canceled.', 'info');
    }
  };

  const handleToggleActive = (index: number) => {
    // Ensure the row is in "editing" mode before toggling
    if (!rows[index].isEditing) {
      showSnackbar(
        "Please click 'Edit' before toggling the active status.",
        'warning',
      );
      return;
    }

    const updatedRows = [...rows];
    updatedRows[index].isActive = !updatedRows[index].isActive;

    setRows(updatedRows);
  };

  const onSortArrowChange = async (sortOrder: any, key: any) => {
    try {
      const payload = {
        pickListGroupId: selectedGroupId,
        sortBy: key,
        sortOrder,
      };

      const response = await SortPicklistItem(payload);

      if (response?.isSuccess) {
        const sortedRows = response.result.map((row: any) => ({
          ...row,
          isActive: row.isactive === 1, // Convert isactive 1/0 to true/false
          isEditing: false, // Ensure all rows are non-editable after sorting
          id: row.pickListItemId,
        }));
        // console.log(sortedRows, "rowrowrowrow");

        setRows(sortedRows);
        console.log('Sort successful:', sortedRows);
      } else {
        console.error(
          'Error sorting items:',
          response?.message || 'Unknown error',
        );
      }
    } catch (error) {
      console.error(
        'Error sorting items:',
        error instanceof Error ? error.message : 'Unknown error',
      );
    }
  };

  const handleTextReset = () => {
    setField1('');
    setField2('');
    setField3('');
    setField4('');
    setField5('');
    setIsAddButtonToggle(true);
  };

  return (
    <div className='data-table-wrapper'>
      <div className='table-container picklist mb-0'>
        <table className='table  vieweditdatatable'>
          <thead>
            <tr>
              {TABLE_HEADERS.map((header) => (
                <th key={header.key}>
                  <div className='d-flex align-items-center'>
                    <span className='me-auto'>{header.placeholder}</span>
                    {showSortingIcons && (
                      <div className='sorticonsection d-flex flex-column'>
                        <button
                          className='material-icons border-0 bg-transparent h-10'
                          disabled={rowdisble ? rowdisble : false}
                          onClick={() => onSortArrowChange('DESC', header.key)}
                        >
                          <span className='material-icons sorticon h-10'>
                            arrow_drop_up
                          </span>
                        </button>

                        <button
                          className='material-icons border-0 bg-transparent h-10'
                          disabled={rowdisble ? rowdisble : false}
                          onClick={() => onSortArrowChange('ASC', header.key)}
                        >
                          <span className='material-icons sorticon h-10'>
                            arrow_drop_down
                          </span>
                        </button>
                      </div>
                    )}
                  </div>{' '}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            <tr>
              <td width='15%'>
                <input
                  placeholder='Item Name'
                  maxLength={100}
                  value={field1}
                  // disabled={rowdisble ? rowdisble : false}
                  disabled={rowdisble || editingRowId !== null}
                  onChange={handleChange(setField1)}
                  style={{
                    width: '100%',
                    padding: '5px',
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                  }}
                />
              </td>
              <td width='15%'>
                <input
                  placeholder='Display Name
'
                  maxLength={200}
                  value={field2}
                  // disabled={rowdisble ? rowdisble : false}
                  disabled={rowdisble || editingRowId !== null}
                  onChange={handleChange(setField2)}
                  style={{
                    width: '100%',
                    padding: '5px',
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                  }}
                />
              </td>
              <td width='15%'>
                <input
                  placeholder='Description'
                  maxLength={300}
                  value={field3}
                  onChange={handleChange(setField3)}
                  // disabled={rowdisble ? rowdisble : false}
                  disabled={rowdisble || editingRowId !== null}
                  style={{
                    width: '400px',
                    padding: '5px',
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                  }}
                />
              </td>
              <td width='15%'>
                <input
                  placeholder='Comments'
                  value={field4}
                  maxLength={1000}
                  onChange={handleChange(setField4)}
                  //disabled={rowdisble ? rowdisble : false}
                  disabled={rowdisble || editingRowId !== null}
                  style={{
                    width: '400px',
                    padding: '5px',
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                  }}
                />
              </td>
              <td width='8%'>
                <input
                  placeholder='Sort Sequence'
                  value={field5 ?? ''}
                  onChange={handleChange(setField5)}
                  // disabled={rowdisble ? rowdisble : false}
                  disabled={rowdisble || editingRowId !== null}
                  style={{
                    width: '100%',
                    padding: '5px',
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                  }}
                />
              </td>
              <td width='8%'>
                <div className='d-flex align-items-center'>
                  <Form.Check
                    type='switch'
                    id='custom-switch'
                    disabled={rowdisble || editingRowId !== null}
                    checked={isAddButtonToggle}
                    // disabled={rowdisble ? rowdisble : false}
                    onChange={handleToggleChange} // Call the toggle function
                  />
                  <span
                    style={{
                      color: isAddButtonToggle ? 'black' : 'red',

                      marginLeft: '2px',
                    }}
                  >
                    {isAddButtonToggle ? 'Active' : 'Inactive'}
                  </span>
                </div>
              </td>
              <td width='8%'>
                {' '}
                <span
                  className='material-icons color_brand'
                  style={{cursor: 'pointer'}}
                >
                  info
                </span>
              </td>
              <td width='8%'>
                <div style={{display: 'flex', margin: '1px'}}>
                  <button
                    className='btn btn-outline-primary d-flex px-2 p-1 align-items-center justify-content-center'
                    // disabled={rowdisble ? rowdisble : false}
                    disabled={rowdisble || editingRowId !== null}
                    onClick={handleAddClick}
                  >
                    <span className='material-symbols-outlined me-1'>
                      add_circle
                    </span>
                    Add
                  </button>
                  <button
                    // disabled={rowdisble ? rowdisble : false}
                    disabled={rowdisble || editingRowId !== null}
                    className='btn   d-flex align-items-center mx-1 p-1 border-0'
                    onClick={handleTextReset}
                  >
                    <span className='material-icons color_brand'>close</span>
                  </button>
                </div>
              </td>
            </tr>
            {currentRows.map((row, index) => (
              <tr key={row.id}>
                {TABLE_HEADERS.map((header) => (
                  <td
                    key={header.key}
                    style={{
                      maxWidth: ['description', 'comments'].includes(header.key)
                        ? '400px'
                        : 'auto',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {header.key === 'isActive' ? (
                      <div className='d-flex align-items-center'>
                        <Form.Check
                          type='switch'
                          id={`switch-${row.id}`}
                          checked={row.isActive}
                          onChange={() =>
                            handleToggleActive(index + indexOfFirstRow)
                          }
                        />
                        <span
                          style={{
                            color: row.isActive ? 'black' : 'red',

                            marginLeft: '8px',
                          }}
                        >
                          {row.isActive ? 'Active' : 'Inactive'}
                        </span>
                      </div>
                    ) : row.isEditing && header.editable ? (
                      /** Display input field when row is in edit mode */
                      <input
                        type='text'
                        className='form-control'
                        value={row[header.key as keyof Row] || ''}
                        onChange={(e) =>
                          handleInputChange(
                            index + indexOfFirstRow,
                            header.key,
                            e.target.value,
                          )
                        }
                      />
                    ) : ['description', 'comments'].includes(header.key) ? (
                      row[header.key as keyof Row] &&
                      row[header.key as keyof Row].length > 50 ? (
                        <OverlayTrigger
                          placement='top'
                          overlay={
                            <Tooltip id={`tooltip-${row.id}-${header.key}`}>
                              {row[header.key as keyof Row]}
                            </Tooltip>
                          }
                        >
                          <span
                            style={{
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: 'block',
                              cursor: 'pointer',
                            }}
                          >
                            {row[header.key as keyof Row].substring(0, 90)}...
                          </span>
                        </OverlayTrigger>
                      ) : (
                        row[header.key as keyof Row]
                      )
                    ) : header.key === 'info' ? (
                      <OverlayTrigger
                        placement='top'
                        overlay={
                          <Tooltip
                            id={`view-tooltip-${row.id}`}
                            style={{backgroundColor: '#6cc0fa'}}
                          >
                            <div>
                              <p className='fw-bold mb-0'>
                                Created By & Created On
                              </p>
                              <p>
                                {row.createdbyName || 'NA'}{' '}
                                <strong>
                                  |<br></br>
                                </strong>{' '}
                                {row.createddate
                                  ? moment(row.createddate).format('MM/DD/YYYY')
                                  : 'N/A'}
                              </p>
                              <p className='fw-bold mb-0'>
                                Last Modified By & Last Modified On
                              </p>
                              <p>
                                {row.modifiedbyName || 'NA'}{' '}
                                <strong>
                                  |<br></br>
                                </strong>{' '}
                                {row.modifieddate
                                  ? moment(row.modifieddate).format(
                                      'MM/DD/YYYY',
                                    )
                                  : 'N/A'}
                              </p>
                            </div>
                          </Tooltip>
                        }
                      >
                        <span
                          className='material-icons color_brand'
                          style={{cursor: 'pointer'}}
                        >
                          info
                        </span>
                      </OverlayTrigger>
                    ) : row.isEditing && header.editable ? (
                      <input
                        type='text'
                        className='form-control'
                        value={(row as any)[header.key] || ''}
                        onChange={(e) =>
                          handleInputChange(
                            index + indexOfFirstRow,
                            header.key,
                            e.target.value,
                          )
                        }
                      />
                    ) : header.key === 'actions' ? (
                      <div className='d-flex align-items-center justify-content-center'>
                        {!row.isEditing ? (
                          <button
                            onClick={() => handleRowAction('edit', row)}
                            className='border-0 bg-transparent'
                          >
                            <span className='material-icons color_brand'>
                              edit
                            </span>
                          </button>
                        ) : (
                          <>
                            <button
                              onClick={() => handleRowAction('save', row)}
                              className='btn btn-sm  d-flex align-items-center px-0 border-0'
                            >
                              <span className='material-icons color_brand'>
                                save
                              </span>
                            </button>
                            <button
                              onClick={() => handleCancel(row)}
                              className='btn btn-sm  d-flex align-items-center px-0 border-0'
                            >
                              <span className='material-icons color_brand'>
                                close
                              </span>
                            </button>
                          </>
                        )}
                      </div>
                    ) : (
                      (row as any)[header.key]
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Snackbar component */}
      <Snackbar
        message={snackbarMessage}
        open={openSnackbar}
        onClose={() => setOpenSnackbar(false)}
        severity={snackbarSeverity}
      />
    </div>
  );
};

export default EditableTable;
